<template>
  <div class="brand-content" v-loading="!data.name">
    <template v-if="data.name">
      <el-image
        class="banner"
        fit="cover"
        :src="require('@/assets/images/tjhj/red-background.png')"
      ></el-image>
      <div class="container">
        <h1>
          <i class="iconfont iconpinpaizhanshi-kecheng pc"></i>
          <span>{{ data.name }}</span>
        </h1>
        <div class="info">主讲老师：{{ data.teachers }} {{ data.school }}</div>
        <div class="content">
          <preview :path="data.url" type="video" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// import preview from "../components/preview.vue";
import { brands } from "@/api/api.js";
import util from "@/libs/util.js";
export default {
  data() {
    return {
      list: null,
      id: null,
      loading: null,
      breadList: [],
      menu: null,
      news: null,
      title: null,
      menuId: null,
      separator: "/",
    };
  },

  // components: {
  //    preview,
  //   NewsContent,
  //   Breadcrumb,
  //   News,
  //   // hotNews
  // },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    getBrand() {
      brands()
        .then((res) => {
          // 处理数据
          let typeDatas = res.wholepageChapterDTOList;
          for (let i = 0; i < typeDatas.length; i++) {
            let orgDatas = typeDatas[i].wholepageItemDTOList;
            for (let j = 0; j < orgDatas.length; j++) {
              let orgData = orgDatas[j];

              for (let k = 0; k < orgData.wholepageDTOList.length; k++) {
                let brand = orgData.wholepageDTOList[k];
                let video = brand.coursepageDTOList[0];

                if (!video) {
                  continue;
                }

                if (parseInt(this.id) === video.resourceid) {
                  this.data = {
                    id: video.resourceid,
                    name: brand.content,
                    cover: video.avatorFullurl,
                    url: video.resourceFullurl,
                    teachers: util.replaceTag(video.note),
                    school: orgData.title,
                  };

                  return;
                }
              }
            }
          }
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    download() {},
  },
};
</script>
<style lang="scss" scoped>
.newsInfo {
  min-height: 100%;
  padding-top: 20px;
}
.content {
  margin-top: 20px;
  padding: 20px 30px;
  background-color: #fff;
  margin-bottom: 80px;
  border: 1px solid #efeff7;
}
.rich-text-wrapper h1 {
  font-size: 22px;
  line-height: 32px;
}

.rich-text-wrapper .info {
  margin: 20px 0;
  font-size: 12px;
  line-height: 16px;
  color: #888;
}
.infoLocation {
  float: left;
  font-size: 14px;
  line-height: 19px;
  vertical-align: middle;
}
@media (max-width: 767px) {
  .breadcrumbBox {
    padding-left: 20px;
    padding-top: 20px;
  }
  .container {
    padding: 0px;
  }
  .content {
    margin-top: 0px;
    margin-bottom: 20px;
    padding: 20px 20px 0px;
    border: none;
  }
  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
}
</style>